export default __webpack_public_path__ + "static/media/approach1.7b43ea6c.png";